import script from "./LaudoModalAtendimento.vue?vue&type=script&setup=true&lang=js"
export * from "./LaudoModalAtendimento.vue?vue&type=script&setup=true&lang=js"

import "./LaudoModalAtendimento.vue?vue&type=style&index=0&id=35f82c83&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35f82c83"]])

export default __exports__